import { xingConnect } from '@xingternal/frame-data-provider';
import { withTracking } from '@xingternal/xing-tracking';
import { trackings } from '@xingternal/platform-layout-trackings';

import { meSelector } from './Me.selectors';
import { Me as MeComponent } from './Me';

const Me = xingConnect(meSelector)(withTracking(trackings)(MeComponent));
export { Me };
